import { type FormSubmission } from "@overmap-ai/common"
import { selectFormSubmissionById } from "@overmap-ai/core"
import { Link } from "@tanstack/react-router"
import { type NodeViewProps, NodeViewWrapper } from "@tiptap/react"
import { memo } from "react"

import { LuIconWithWrapper } from "../../../../components/Icons/LuIconWithWrapper"
import { FormSubmissionIndexLabel } from "../../../../components/IndexLabels/FormSubmissionIndexLabel"
import { modelIconMapping } from "../../../../mappings/icons"
import { useAppSelector } from "../../../../store"

export const FormSubmissionMentionComponent = memo((props: NodeViewProps) => {
	const { node } = props
	const { uuid } = node.attrs as { uuid: FormSubmission["uuid"] }

	const formSubmission = useAppSelector(selectFormSubmissionById(uuid))

	return (
		<NodeViewWrapper
			className="bg-(--base-a3) py-0.25 inset-ring inset-ring-(--base-a6) rounded-md px-1 align-bottom"
			as="span"
		>
			{!!formSubmission && (
				<Link
					className="whitespace-nowrap"
					from="/$organizationId"
					to="/$organizationId/forms/submissions/$formSubmissionId"
					params={(prev) => ({ ...prev, formSubmissionId: formSubmission.uuid })}
				>
					<LuIconWithWrapper
						icon={modelIconMapping.form}
						color="var(--base-12)"
						background={false}
						className="align-sub"
					/>
					<FormSubmissionIndexLabel formSubmissionId={formSubmission.uuid} />
				</Link>
			)}
		</NodeViewWrapper>
	)
})
FormSubmissionMentionComponent.displayName = "FormSubmissionMentionComponent"
